// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rmp-container {
  padding: 30px;
  background: #020617;
  min-height: 100vh;
  color: white;
  font-family: Inter;
}

.menu-card {
  border-radius: 14px;
  margin-bottom: 12px;
  background: #020617;
  border: 1px solid #1e293b;
  overflow: hidden;
}

.menu-header {
  all: unset;
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: 16px 18px;
  box-sizing: border-box;
}     

.menu-left {
  display: flex;
  gap: 10px;
  align-items: center;
  flex: 1 1;
}

.menu-content {
  padding: 15px;
}

.submenu {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}

.submenu-item {
  display: flex;
  gap: 8px;
  padding: 10px;
  background: #020617;
  border: 1px solid #1e293b;
  border-radius: 10px;
}

.submit-btn {
  margin-top: 20px;
  padding: 12px;
  width: 200px;
  background: #3b82f6;
  border: none;
  border-radius: 8px;
  color: white;
}

/* DIALOG */

.permission-dialog {
  width: 420px;
  padding: 24px;
  border-radius: 16px;
  background: white;
}

.permission-list {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.permission-item {
  display: flex;
  justify-content: space-between;
  padding: 14px;
  border-radius: 10px;
  background: #f3f4f6;
}

.permission-save-btn {
  margin-top: 20px;
  padding: 12px;
  width: 100%;
  background: green;
  color: white;
  border: none;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/RoleMenuPermission/AddRoleMenuPermission/AddRoleMenuPermission.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA,WAAW;;AAEX;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".rmp-container {\n  padding: 30px;\n  background: #020617;\n  min-height: 100vh;\n  color: white;\n  font-family: Inter;\n}\n\n.menu-card {\n  border-radius: 14px;\n  margin-bottom: 12px;\n  background: #020617;\n  border: 1px solid #1e293b;\n  overflow: hidden;\n}\n\n.menu-header {\n  all: unset;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 16px 18px;\n  box-sizing: border-box;\n}     \n\n.menu-left {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex: 1;\n}\n\n.menu-content {\n  padding: 15px;\n}\n\n.submenu {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 10px;\n}\n\n.submenu-item {\n  display: flex;\n  gap: 8px;\n  padding: 10px;\n  background: #020617;\n  border: 1px solid #1e293b;\n  border-radius: 10px;\n}\n\n.submit-btn {\n  margin-top: 20px;\n  padding: 12px;\n  width: 200px;\n  background: #3b82f6;\n  border: none;\n  border-radius: 8px;\n  color: white;\n}\n\n/* DIALOG */\n\n.permission-dialog {\n  width: 420px;\n  padding: 24px;\n  border-radius: 16px;\n  background: white;\n}\n\n.permission-list {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.permission-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 14px;\n  border-radius: 10px;\n  background: #f3f4f6;\n}\n\n.permission-save-btn {\n  margin-top: 20px;\n  padding: 12px;\n  width: 100%;\n  background: green;\n  color: white;\n  border: none;\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
